import { useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

// Hooks
import { useAppSelector } from "app/hooks";

// Store
import { getSavedSearchName } from "store/slice/currentSearch";

// Enums
import { urlPaths } from "enums/urlPaths";
import { ChartRouteNames } from "enums/chartEnums";

// Utils
import { buildParamsString } from "utils";

const useProjectionHeader = (): {
    searchName: string;
    companyInfoVisible: boolean;
    isPathToImprovementVisible: boolean;
    handleBackToInsights: () => void;
    handleGoToDashboard: () => void;
    handleClickToImprovement: () => void;
    handleToggleCompanyInfo: () => void;
    handleClickAway: () => void;
} => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const { pathname } = useLocation();
    const isPathToImprovementVisible = pathname.includes("bridge");

    const { companyId } = useParams();
    const projectId = searchParams.get("projectId");
    const insightId = searchParams.get("insightId");
    const briefId = searchParams.get("briefId");
    const searchAiId = searchParams.get("searchAiId");
    const params = buildParamsString({ projectId, insightId, briefId, searchAiId });

    const searchName = useAppSelector(getSavedSearchName);

    const [companyInfoVisible, toggleCompanyInfo] = useState(false);

    const handleBackToInsights = () => {
        if (isPathToImprovementVisible) {
            navigate(`${urlPaths.Projection}/${companyId}/${ChartRouteNames.Balance}?${params}`, {
                state: { from: urlPaths.Projection },
            });
        } else {
            navigate(`${urlPaths.ProjectDashboard}/${projectId}`);
        }
    };

    const handleGoToDashboard = () => {
        navigate(`${urlPaths.ProjectDashboard}/${projectId}`);
    };

    const handleClickToImprovement = () => {
        navigate(`${urlPaths.PathToImprovement}/${companyId}/${ChartRouteNames.Bridge}?${params}`);
    };

    const handleToggleCompanyInfo = () => toggleCompanyInfo(!companyInfoVisible);

    const handleClickAway = () => toggleCompanyInfo(false);

    return {
        searchName,
        companyInfoVisible,
        isPathToImprovementVisible,
        handleBackToInsights,
        handleGoToDashboard,
        handleClickToImprovement,
        handleToggleCompanyInfo,
        handleClickAway,
    };
};

export default useProjectionHeader;
